// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"EditorToolbar_toolbar__2oYML"};